import { CRMList } from '../CRMList/CRMList';
import { ProjectForCRM } from "../ProjectForCRM/ProjectForCRM";
import { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';


const CRMPage = () => {

    const path = useParams()
    const navigate = useNavigate()
    const [selectedProject, setSelectedProject] = useState(null)

     useEffect(() => {
        if (path['*'] === '') {
            navigate('/crm/project-for-crm/project')
            setSelectedProject(null)
        }
    }, [path])

    return (
        <Routes>
            <Route path='project-for-crm/*' element={<ProjectForCRM selectedProject={selectedProject} setSelectedProject={(e) => setSelectedProject(e)}/>} />
            <Route path='crm-list/*' element={<CRMList setSelectedProjectAbove={e => setSelectedProject(e)} />} />
        </Routes>
    )
}

export { CRMPage }